export default __webpack_public_path__ + "locales/it/Errors.json?hash=cc6d0ac943f1291481cc68e6f3c44755";